<template>
  <el-config-provider :locale="locale">
    <el-container style="height: 100vh; display: flex; flex-direction: column;">
      <el-header style="display: flex; align-items: center; flex-shrink: 0;">
        <el-text size="large" type="danger"></el-text>
        <el-image style="width: 10%;"
          src="https://srb-data.oss-cn-beijing.aliyuncs.com/issue/2023/11/28/compass1.png/a32f9f58-bb14-4972-9b68-09b32cbafbbc"></el-image>
        <div style="margin-left: auto;">
          <el-dropdown @command="changeLocale">
            <span style="font-size: 14px;" class="el-dropdown-link">
              {{ label_language }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item style="font-size: 14px" command="zhCn">简体中文</el-dropdown-item>
                <el-dropdown-item style="font-size: 14px" command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>
      <el-main style="flex: 1; overflow-y: auto;">
        <el-row>
          <el-col :span="14"></el-col>
          <el-col :span="5">
            <el-form id="loginForm" ref="loginForm" :model="form" :rules="rules" label-width="80px" class="login-box"
              @keyup.enter="onSubmit('loginForm')">
              <h3 class="login-title">{{ $t('login.title', { msg: 'login.title' }) }}</h3>
              <el-form-item :label="$t('login.username', { msg: 'login.username' })" prop="username">
                <el-input :placeholder="$t('login.usernameP', { msg: 'login.usernameP' })" v-model="form.username"
                  auto-complete="off" size="large">
                  <template #prefix>
                    <i class="el-input__icon el-icon-user"></i>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('login.password', { msg: 'login.password' })" prop="password">
                <el-input type="password" :placeholder="$t('login.passwordP', { msg: 'login.passwordP' })"
                  v-model="form.password" auto-complete="off" size="large">
                  <template #prefix>
                    <i class="el-input__icon el-icon-key"></i>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button :disabled="loadingBtn" type="primary" class="loginButton" round size="large"
                  v-on:click="onSubmit('loginForm')">{{ $t('login.login', { msg: 'login.login' }) }}</el-button>
              </el-form-item>
              <div style="text-align: left;">
                <el-text style="font-size: 14px">{{ $t('login.info', { msg: 'login.info' }) }}<el-link
                    style="font-size: 14px;color: rgb(0, 76, 255);margin-top: -3px;" @click="applyAccont()">{{
                      $t('login.apply', { msg: 'login.apply' }) }}</el-link></el-text>
              </div>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
      <!-- 申请信息 -->
      <el-dialog :title="$t('login.sysInfo', { msg: 'login.sysInfo' })" v-model="showApply" width="50%" center
        destroy-on-close>
        <h4>{{ $t('login.welcomeToUse', { msg: 'login.welcomeToUse' }) }}{{ $t('login.issueInfo', {
          msg:
            'login.issueInfo'
        })
          }}</h4><br>
        <p>
          <span> {{ $t('login.introducea', { msg: 'login.introducea' }) }} </span><br>
          <span> {{ $t('login.introduceb', { msg: 'login.introduceb' }) }} </span><br>
          <span> {{ $t('login.introducec', { msg: 'login.introducec' }) }} </span><br>
          <span> {{ $t('login.introduced', { msg: 'logi n.introduced' }) }} </span><br><br>
          <span class="inline-elements">
            <!-- {{ $t('login.introducee', { msg: 'login.introducee' }) }}
          &nbsp;<el-link type="primary" @click="handlePayAccount()">{{ $t('login.here', { msg: 'login.here' }) }}</el-link>&nbsp;
          {{ $t('login.introducef', { msg: 'login.introducef' }) }} -->
            {{ $t('login.introducee', { msg: 'login.introducee' }) }}
            <div>
              &nbsp;<el-link type="primary" @click="openDialog">{{ $t('login.here', { msg: 'login.here' })
                }}</el-link>&nbsp;

              <!-- 弹出框 -->
              <el-dialog title="请选择身份" v-model="dialogVisibleNew" width="50%" @close="reset1SelectedType">

                <el-radio v-model="radio" label="1">专家</el-radio>
                <el-radio v-model="radio" label="2">用户</el-radio>

                <div v-if="radio === '1'">


                  <el-form class="custom-form" ref="expertForm" width="100%" :model="expertForm" :rules="expertRules">
                   
                    <el-row :gutter="20">
                      <!-- 剩下的文本框部分，占据两块（12列） -->
                      <el-col :span="24">
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="姓名" prop="name">
                              <el-input v-model="expertForm.name"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="用户" prop="username">
                              <el-input v-model="expertForm.username"></el-input>
                            </el-form-item>
                          </el-col>

                          <el-col :span="12">
                            <el-form-item label="邮箱" prop="email">
                              <el-input v-model="expertForm.email"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="电话" prop="phoneNumber">
                              <el-input v-model="expertForm.phoneNumber"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="公司" prop="company">
                              <el-input v-model="expertForm.company"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>

                      </el-col>

                    </el-row>



                    <!-- <el-row>  -->


                    <!-- </el-row> -->


                    <!-- <el-form-item label="技能" prop="qualifications">
                      <el-input v-model="expertForm.qualifications"></el-input>
                    </el-form-item> -->
                    <el-form-item label="简介" prop="biography">
                      <el-input type="textarea" v-model="expertForm.biography"
                        :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
                    </el-form-item>


                    <!-- <el-form-item label="经验" prop="yearsOfExperience">
                      <el-radio-group v-model="expertForm.yearsOfExperience">
                        <el-radio-button label="1">&lt;3年</el-radio-button>
                        <el-radio-button label="2">3~5年</el-radio-button>
                        <el-radio-button label="3">5~10年</el-radio-button>
                        <el-radio-button label="4">>10年</el-radio-button>
                      </el-radio-group>
                    </el-form-item> -->

                    <el-form-item label="语言" prop="selectedLanguages">
                      <el-select v-model="expertForm.selectedLanguages" multiple placeholder="请选择语言">
                        <el-option v-for="language in languageOptions" :key="language.value" :label="language.label"
                          :value="language.label"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="年限" prop="yearsOfExperience">
                      <div class="experience-container">
                      <span>于</span>
                      <input
                        type="date"
                        v-model="expertForm.yearsOfExperience"
                        placeholder="选择日期"
                        class="custom-date-input"
                      />
                      <span>从事工作</span>
                    </div>
                    </el-form-item>



                    <!-- <el-form-item label="标签" prop="selectedLabels">
                      <el-select v-model="expertForm.selectedLabels" multiple filterable placeholder="修改标签"
                        class="custom-width">
                        <el-option v-for="item in expertLabelOptions" :key="item" :label="item" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-form-item label="标签" prop="dynamicTags">
                      <el-tag :key="tag" v-for="tag in expertForm.dynamicTags" closable :disable-transitions="false"
                        @close="handleCloseTag(tag)">
                        {{ tag }}
                      </el-tag>
                      <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
                        size="small" @keyup.enter="handleInputConfirm" @blur="handleInputConfirm">
                      </el-input>
                      <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
                    </el-form-item>

                    <el-form-item label="密码" prop="password">
                      <el-input type="password" v-model="expertForm.password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认" prop="confirmPassword">
                      <el-input type="password" v-model="expertForm.confirmPassword"></el-input>
                    </el-form-item>



                    <!-- 根据需要添加更多表单项 -->
                    <!-- ... -->

                    <el-form-item>
                      <el-button type="primary" @click="submitExpertForm">注册</el-button>
                      <el-button @click="resetExpertForm">重置</el-button>
                    </el-form-item>
                  </el-form>
                  <!-- </el-dialog> -->

                  <!-- 你的专家界面内容 -->
                </div>

                <div v-if="radio === '2'">
                  <!-- 成为普通用户的界面 -->
                  <!-- <el-dialog :title="$t('login.applyPay', { msg: 'login.applyPay' })" v-model="showPay" width="50%" center -->
                  <!-- destroy-on-close> -->
                  <!-- <el-form> -->
                  <el-form class="custom-form" ref="outsiderFrom" :model="outsiderFrom" :rules="rulespay"
                    label-width="90px">
                    <el-form-item :label="$t('applyoutsider.username', { msg: 'applyoutsider.username' })"
                      prop="username">
                      <el-input v-model="outsiderFrom.username"
                        :placeholder="$t('applyoutsider.tipsusername', { msg: 'applyoutsider.tipsusername' })"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('applyoutsider.password', { msg: 'applyoutsider.password' })"
                      prop="passwordPlainText">
                      <el-input v-model="outsiderFrom.passwordPlainText"
                        :placeholder="$t('applyoutsider.tipspassword', { msg: 'applyoutsider.tipspassword' })"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('applyoutsider.name', { msg: 'applyoutsider.name' })" prop="name">
                      <el-input v-model="outsiderFrom.name"
                        :placeholder="$t('applyoutsider.tipsname', { msg: 'applyoutsider.tipsname' })"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('applyoutsider.role', { msg: 'applyoutsider.role' })" prop="roleId">
                      <el-select v-model="outsiderFrom.roleId"
                        :placeholder="$t('applyoutsider.tipsrole', { msg: 'applyoutsider.tipsrole' })"
                        style="width: 100%">
                        <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('applyoutsider.companyName', { msg: 'applyoutsider.companyName' })"
                      prop="companyName" v-if="outsiderFrom.roleId != 5">
                      <el-input v-model="outsiderFrom.companyName"
                        :placeholder="$t('applyoutsider.tipscompanyname', { msg: 'applyoutsider.tipscompanyname' })"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('applyoutsider.email', { msg: 'applyoutsider.email' })" prop="email">
                      <el-input v-model="outsiderFrom.email"
                        :placeholder="$t('applyoutsider.tipsemail', { msg: 'applyoutsider.tipsemail' })"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align: center;">
                      <el-button type="primary" @click="onSubmitpay('outsiderFrom')">{{ $t('login.registry', {
                        msg:
                          'login.registry'
                      })
                        }}</el-button>
                      <el-button @click="resetFormpay('outsiderFrom')">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' })
                        }}</el-button>
                    </el-form-item>
                  </el-form>
                  <!-- </el-form> -->
                  <!-- </el-dialog> -->
                  <!-- 你的普通用户界面内容 -->


                </div>


                <template v-slot:footer>
                  <!-- <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">关闭</el-button>
                  </span> -->
                </template>
              </el-dialog>
            </div>
            {{ $t('login.introducef', { msg: 'login.introducef' }) }}
          </span>

        </p>
      </el-dialog>

      <el-dialog :title="$t('login.applyPay', { msg: 'login.applyPay' })" v-model="showPay" width="50%" center
        destroy-on-close>
        <el-form ref="outsiderFrom" :model="outsiderFrom" :rules="rulespay" label-width="90px">
          <el-form-item :label="$t('applyoutsider.username', { msg: 'applyoutsider.username' })" prop="username">
            <el-input v-model="outsiderFrom.username"
              :placeholder="$t('applyoutsider.tipsusername', { msg: 'applyoutsider.tipsusername' })"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyoutsider.password', { msg: 'applyoutsider.password' })"
            prop="passwordPlainText">
            <el-input v-model="outsiderFrom.passwordPlainText"
              :placeholder="$t('applyoutsider.tipspassword', { msg: 'applyoutsider.tipspassword' })"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyoutsider.name', { msg: 'applyoutsider.name' })" prop="name">
            <el-input v-model="outsiderFrom.name"
              :placeholder="$t('applyoutsider.tipsname', { msg: 'applyoutsider.tipsname' })"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyoutsider.role', { msg: 'applyoutsider.role' })" prop="roleId">
            <el-select v-model="outsiderFrom.roleId"
              :placeholder="$t('applyoutsider.tipsrole', { msg: 'applyoutsider.tipsrole' })" style="width: 100%">
              <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('applyoutsider.companyName', { msg: 'applyoutsider.companyName' })"
            prop="companyName" v-if="outsiderFrom.roleId != 5">
            <el-input v-model="outsiderFrom.companyName"
              :placeholder="$t('applyoutsider.tipscompanyname', { msg: 'applyoutsider.tipscompanyname' })"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyoutsider.email', { msg: 'applyoutsider.email' })" prop="email">
            <el-input v-model="outsiderFrom.email"
              :placeholder="$t('applyoutsider.tipsemail', { msg: 'applyoutsider.tipsemail' })"></el-input>
          </el-form-item>
          <el-form-item style="text-align: center;">
            <el-button type="primary" @click="onSubmitpay('outsiderFrom')">{{ $t('login.registry', {
              msg:
                'login.registry'
            })
              }}</el-button>
            <el-button @click="resetFormpay('outsiderFrom')">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' })
              }}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-footer style="text-align: center;">
        <br>
        <div class="footerlink">
          <el-space :size="30">
            <el-link style="font-size: 14px" target="_blank" @click="handleContact()"><el-text>{{ $t('login.contact', {
              msg:
                'login.contact'
            }) }}</el-text></el-link>
            <el-link style="font-size: 14px" target="_blank" @click="handleToHelp()"><el-text>{{ $t('login.help', {
              msg:
                'login.help'
            }) }}</el-text></el-link>
            <el-text style="color: black;font-size: 14px;">
              © {{ $t('login.copyRight', { msg: 'login.copyRight' }) }}1999 - {{ year }}{{ $t('login.compass', {
                msg:
                  'login.compass'
              }) }}
            </el-text>
            <el-text style="font-size: 14px;">
              <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
                <img src="../assets/images/anbei.png" style="width: 20px; height: 20px; vertical-align: middle;">
                沪公网安备31010602008934号
              </a>
            </el-text>
            <el-text style="font-size: 14px;"><a href="http://beian.miit.gov.cn/"
                target="_blank">沪ICP备17010737号</a></el-text>
          </el-space>
        </div>
      </el-footer>
    </el-container>
  </el-config-provider>
</template>

<script>
import { getallrole, login, registry } from '@/axios/index.js'
import { ElMessage } from "element-plus";
import store from "@/stores";
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import { baseUrl_New } from '../axios/urlconfig';
import axios from 'axios';
import ApplyExpert from '@/home/expert/applyexpert';
import { getRequest, postRequest } from '../axios/axios';

export default {
  name: "Login",
  data() {
    return {
      // dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      expertLabelOptions: [],
      // selectedLabels: [],


      value1: '',

      radio: '2',
      dialogVisibleNew: false,
      selectedType: null,

      isExpertSelected: false, // 控制专家注册对话框的显示
      expertForm: {
        dynamicTags: [],

        phoneNumber: '',
        name: '',
        username: '',
        email: '',
        qualifications: '',
        location: '',
        biography: '',
        yearsOfExperience: '', // 初始化
        profileImage: '',
        password: '',
        // languagesSpoken: [],
        // expertLables: [],
        selectedLabels: [],
        selectedLanguages: [],
        company: '',



        // 根据需要添加更多表单字段
      },
      imageUrl: '', // 保存文件URL
      uploadUrl: '/api/profile/upload', // 上传图片的后端接口
      // languageOptions: ['English', 'French', 'Spanish', 'Chinese', 'Japanese'],
      languageOptions: [{
        value: '选项1',
        label: 'English'
      }, {
        value: '选项2',
        label: 'French'
      }, {
        value: '选项3',
        label: 'Spanish'
      }, {
        value: '选项4',
        label: 'Chinese'
      }, {
        value: '选项5',
        label: 'Japanese'
      }],

      // selectedLanguages: [],
      // languageOptions: [
      //   { value: 'English', label: '英语' },
      //   { value: 'Spanish', label: '西班牙语' },
      //   { value: 'Japanese', label: '日语' }],

      expertRules: {
        dynamicTags: [
          {
            required: true,
            message: '请绑定至少一个标签',
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error('请绑定至少一个标签'));
              }
            }
          }
        ],
        yearsOfExperience: [{ required: true, message: '请选择年限', trigger: 'change' }],
        selectedLanguages: [
          { required: true, message: '请选择至少一种语言', trigger: 'change' }
        ],
        selectedLabels: [{ required: true, message: '请选择至少一种标签', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        qualifications: [{ required: true, message: '请输入技能', trigger: 'blur' }],
        // biography: [{ required: true, message: '请输入简介', trigger: 'blur' }],
        yearOfExperience: [{ required: true, message: '请选择经验', trigger: 'change' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.expertForm.password) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        phoneNumber: [
          { required: true, message: '请输入电话号', trigger: 'blur' },

          {
            validator: (rule, value, callback) => {

              // 允许为空，但非空时需要进行长度和格式校验
              if (value && !/^\d{11}$/.test(value)) {
                callback(new Error('联系电话应为 11 位数字'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        company: [{ required: true, message: '请输入公司名', trigger: 'blur' }],

        // profileImage: [{ required: true, message: '请上传头像', trigger: 'change' }]
      },

      components: {
        ApplyExpert,
      },

      label_language: localStorage.getItem('yuyan') || '请选择',
      locale: localStorage.getItem('lan') || 'zh-cn',
      language: localStorage.getItem('language') || 'zh-cn',
      payDetail: false,
      showApply: false,
      loadingBtn: false,
      form: {
        username: '',
        password: ''
      },
      allrole: [],
      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      rules: {
        username: [
          { required: true, message: this.$t('login.notnull', { msg: 'login.notnull' }), trigger: 'blur' }
          // {required: true, trigger: 'blur'}
        ],
        password: [
          { required: true, message: this.$t('login.notnullp', { msg: 'login.notnullp' }), trigger: 'blur' }
          // {required: true, trigger: 'blur'}
        ]
      },

      // 对话框显示和隐藏
      dialogVisible: false,
      // 对话框显示和隐藏
      registryForm: {
        username: '',
        password: '',
        name: '',
        year: '',
        usercompany: []
      },
      registryDailog: false,
      registryRules: {
        username: [
          { required: true, message: this.$t('login.notnull', { msg: 'login.notnull' }), trigger: 'blur' },
          { min: 1, max: 15, message: this.$t('kbType.lengthD15', { msg: 'kbType.lengthD15' }), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('login.nameP', { msg: 'login.nameP' }), trigger: 'change' },
          { min: 1, max: 50, message: this.$t('user.lengthD150', { msg: 'user.lengthD150' }), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('login.emailP', { msg: 'login.emailP' }), trigger: 'blur' },
          { pattern: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/, message: this.$t('user.emailP', { msg: 'user.emailP' }), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('login.passwordP', { msg: 'login.passwordP' }), trigger: 'blur' },
          { min: 6, max: 15, message: this.$t('user.lengthD615', { msg: 'user.lengthD615' }), trigger: 'blur' }
        ]
      },
      //付费注册
      outsiderFrom: {
        "companyName": '',
        "email": '',
        "name": '',
        "password": '',
        "roleId": null,
        "username": ''
      },
      options: [
        {
          id: 1,
          value: 3,
          label: this.$t('applyoutsider.customer', { msg: 'applyoutsider.customer' })
        }, {
          id: 2,
          value: 4,
          label: this.$t('applyoutsider.opuser', { msg: 'applyoutsider.opuser' })
        },
        // {
        //   id: 3,
        //   value: 5,
        //   label: this.$t('applyoutsider.opexpert', { msg: 'applyoutsider.opexpert' })
        // }
      ],
      rulespay: {
        name: [
          { required: true, message: this.$t('login.nameP', { msg: 'login.nameP' }), trigger: 'blur' },
          { min: 1, max: 50, message: this.$t('user.lengthD150', { msg: 'user.lengthD150' }), trigger: 'blur' }
        ],
        passwordPlainText: [
          { required: true, message: this.$t('login.passwordP', { msg: 'login.passwordP' }), trigger: 'blur' },
          { min: 6, max: 15, message: this.$t('user.lengthD615', { msg: 'user.lengthD615' }), trigger: 'blur' }
        ],
        username: [
          { required: true, message: this.$t('login.notnull', { msg: 'login.notnull' }), trigger: 'blur' },
          { min: 1, max: 15, message: this.$t('kbType.lengthD15', { msg: 'kbType.lengthD15' }), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('login.emailP', { msg: 'login.emailP' }), trigger: 'blur' },
          { pattern: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/, message: this.$t('user.emailP', { msg: 'user.emailP' }), trigger: 'blur' }
        ],
        roleId: [
          { required: true, message: this.$t('applyoutsider.tipsrole', { msg: 'applyoutsider.tipsrole' }), trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: this.$t('applyoutsider.tipscompanyname', { msg: 'applyoutsider.tipscompanyname' }), trigger: 'blur' }
        ]
      },
      showPay: false,

    }
  },
  created() {
    this.clearSession();
    this.getallrole();
    this.nowYear();
    this.getExpertLabel();

  },
  computed: {
    localeF() {
      return this.language === 'zh-cn' ? zhCn : en
    }
  },
  methods: {
    handleCloseTag(tag) {
      this.expertForm.dynamicTags.splice(this.expertForm.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.expertForm.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    getExpertLabel() {
      getRequest(baseUrl_New + "/expert/label").then(res => {
        this.expertLabelOptions = res.data.data;
      });
    },
    handleAvatarChange(file) {
      // this.expertForm.profileImage = file.raw; // 保存文件对象
      this.imageUrl = file;
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = e => {
        this.imageUrl = e.target.result; // 本地显示图片
      };
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.imageUrl = response.data.url; // 设置图片URL
      } else {
        this.$message.error('上传失败');
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    selectType(type) {
      this.selectedType = type;
      if (type === 'expert') {
        this.isExpertSelected = true; // 显示专家注册表单
      }
      if (type === '用户') {
        this.isUserSelected = true; // 
      }
    },
    resetSelectedType() {
      this.selectedType = null;
      this.isExpertSelected = false; // 隐藏专家注册表单
    },

    submitExpertForm() {
      this.$refs.expertForm.validate((valid) => {
        if (valid) {


          this.expertForm.languagesSpoken = this.expertForm.selectedLanguages.map(language => ({ language }));
          // this.expertForm.expertLabel = this.expertForm.selectedLabels.map(label => ({ label }));
          this.expertForm.expertLabel = this.expertForm.dynamicTags.map(label => ({ label }));


          // 使用 FormData 对象进行 POST 请求
          axios.post(baseUrl_New + '/expert/add', this.expertForm)

            .then(response => {
              this.$message.success('注册成功');
              this.isExpertSelected = false; // 关闭对话框
              this.resetExpertForm();
            })
            .catch(error => {
              let errorMessage = '注册失败';
              if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
              }

              this.$message.error(errorMessage);
              console.error(error);
            });
        } else {
          this.$message.error('表单验证失败，请检查输入!');
          return false;
        }
      });
    },


    resetExpertForm() {
      this.$refs.expertForm.resetFields(); // 重置表单字段
      this.selectedLanguages = [];
      this.expertForm.profileImage = ''; // 重置上传的图片
      this.expertForm.yearsOfExperience = '';
      this.selectedLabels = [];
      // 根据需要重置其他表单字段
    },


    openDialog() {
      this.dialogVisibleNew = true;
    },

    reset1SelectedType() {
      this.selectedType = null;
      this.dialogVisibleNew = null;
    },
    clearSession() {
      sessionStorage.clear();
    },
    changeLocale(command) {
      if (command === 'zhCn') {
        this.label_language = '简体中文';
        localStorage.setItem("yuyan", this.label_language);
        this.lan = 'zh-cn';
        localStorage.setItem("lan", this.lan);
        this.language = 'zh-cn';
        localStorage.setItem("language", this.language);
        this.locale = 'zh-cn';
        localStorage.setItem('locale', this.locale);
        window.location.reload()
      } else if (command === 'en') {
        this.label_language = 'English';
        localStorage.setItem('yuyan', this.label_language);
        this.language = 'en';
        localStorage.setItem('language', this.language)
        this.lan = 'en';
        localStorage.setItem('lan', this.lan);
        window.location.reload()
      }
    },
    onSubmit(formName) {
      // 为表单绑定验证功能
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingBtn = true;
          login({
            'username': this.form.username,
            'password': this.form.password
          }).then(res => {
            console.log(res);
            if (res.code === 401) {
              this.loadingBtn = false;
            }
            if (res.msg === '登录成功') {
              // this.$message.success(this.$t('login.loginS', { msg: 'login.loginS' }),);
              this.$message({
                message: this.$t('login.loginS', { msg: 'login.loginS' }),
                type: 'success',
                offset: 40
              })
              store.commit('setusername', this.form.username);
              store.commit('setuserid', res.data.principal.id);
              let roleID = [];
              res.data.principal.usercompany.forEach(item => roleID.push(item.roleID));
              let role = [];
              this.allrole.filter(item => roleID.includes(item.value)).forEach(item => role.push(item.label));
              sessionStorage.setItem('role', role.toString());
              sessionStorage.setItem('username', this.form.username);
              sessionStorage.setItem('userid', res.data.principal.id);
              sessionStorage.setItem('name', res.data.principal.name);
              let companyID = [];
              res.data.principal.usercompany.forEach(item => companyID.push(item.companyID));
              sessionStorage.setItem('companyID', companyID.toString());
              let usercompany = [];
              sessionStorage.setItem('usercompany', JSON.stringify(res.data.principal.usercompany));
              sessionStorage.setItem('token', res.token);
              // console.log('类型'+res.data.usercompany[0]);
              localStorage.setItem('lan', this.lan);
              localStorage.setItem('language', this.language);
              this.loadingBtn = false;
              this.$router.push({
                name: 'issue',
                params: {
                  username: this.form.username,
                  userid: res.data.principal.id,
                  name: res.data.principal.name,
                  companyID: companyID,
                  usercompany: res.data.principal.usercompany,
                }
              });
            }
            else {
              this.$message({
                message: this.$t('login.usernameOrPasswordError', { msg: 'login.usernameOrPasswordError' }),
                offset: 0,
                type: 'error'
              })
              this.loadingBtn = false;
              // ElMessage.error(this.$t('login.usernameOrPasswordError', { msg: 'login.usernameOrPasswordError' }));
              this.form.password = '';
            }
          }).catch(err => {
            this.loadingBtn = false;
            console.log(err);
          });
        } else {
          this.dialogVisible = false;
          this.loadingBtn = false;
          this.$message.error(this.$t('login.loginTm', { msg: 'login.loginTm' }));
          return false;
        }
      });
    },

    getallrole() {  //得到所有角色信息
      getallrole().then(res => {
        this.allrole = res.data;
      }).catch(err => {
        console.log(err);
      })
    },


    submitForm(formName) {  //提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          registry(this.registryForm).then(res => {
            // console.log(res);
            if (res.msg === '注册成功') {
              ElMessage.success(this.$t('login.registryS', { msg: 'login.registryS' }));
              this.registryForm.name = '';
              this.registryForm.username = '';
              this.registryForm.password = '';
              this.registryDailog = false;
            } else {
              ElMessage.error(res.msg)
              console.log('error submit!!');
            }
          })
        } else {
          return false;
        }
      });
    },


    nowYear() {
      let nowDate = new Date();
      let date = nowDate.getFullYear();
      this.year = date;
    },

    handleAbout() {
      this.$router.push({
        path: '/details',
      });

    },
    handleContact() {
      this.$router.push({
        path: '/contact',
      });
    },
    handleToHelp() {
      this.$router.push({
        path: '/help',
      });
    },

    applyAccont() {
      this.showApply = true
    },

    handleTrail() {
      this.showTrial = true;
      this.showApply = false;
    },
    handleFreeAccount() {
      this.registryDailog = true;
      this.showApply = false;
    },
    handlePayAccount() {
      this.showPay = true;
      this.showApply = false;
    },
    returnLogin() {
      this.showApply = false;
      this.showTrial = false;
      this.showPay = false;
    },
    //付费注册
    onSubmitpay(formName) { //新增用户
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this
          axios.post(baseUrl_New + '/out/addOut', {
            companyName: this.outsiderFrom.companyName,
            email: this.outsiderFrom.email,
            name: this.outsiderFrom.name,
            passwordPlainText: this.outsiderFrom.passwordPlainText,
            roleId: this.outsiderFrom.roleId,
            username: this.outsiderFrom.username
          }).then(resp => {
            this.$message.success(this.$t('applyoutsider.applysucc', { msg: 'applyoutsider.applysucc' }));
            this.resetFormpay('outsiderFrom');
            this.showPay = false;
          }).catch(err => {
            console.log(err);
          });
        }
      });

    },
    resetFormpay(outsiderFrom) {
      this.$refs[outsiderFrom].resetFields();
    },

  }
}
</script>

<style lang="scss" scoped>
.el-main {
  flex: 1;
  overflow-y: auto;
}

.el-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.el-header {
  background-color: white;
  height: 6%;
}

.el-form-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.loginButton {
  vertical-align: middle;
  margin-right: 0px;
  width: 100%;
  font-size: 14px;
}

.el-text {
  display: flex;
  align-items: center;
}

.el-header,
.el-footer {
  background-color: white;
  text-align: center;
}

.login-box {
  border: 1px solid #DCDFE6;
  width: 150%;
  height: 50%;
  margin: 50% auto;
  padding: 10% 15% 10% 10%;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  box-shadow: 0 0 25px #909399;
  background-color: white;
}

.login-title {
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto 30px auto;
  color: #303133;
}

.el-input {
  width: 100%;
  size: large;
  margin-bottom: 0;
}

.footerlink {
  font-size: 14px;
}

.inline-elements {
  display: inline-flex;
  align-items: center;
}

.el-container {
  background-image: url("../assets/images/issuebackground1.jpg");
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center center;
}

.dialog-footer {
  text-align: right;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;


}



.el-form {
  width: 500px;
  /* 调整表单的宽度 */
  padding: 20px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.el-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.avatar-uploader {
  display: block;
  width: 100%;
  text-align: center;
}

.avatar-uploader img {
  width: 100%;
  height: auto;
}

.form-container {
  width: 100%;
  /* 设置表单宽度，可以根据需要调整 */
  margin: 0 auto;
  /* 居中 */

}

.custom-form {
  box-shadow: none;
  /* 去除阴影 */
  border: none;
  /* 去除边框 */
  width: 100%;
  /* 设置表单宽度 */
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.experience-container {
  display: flex;
  align-items: center;
}
.custom-date-input {
  height: 40px;
  padding: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  width: auto; /* 调整为自动宽度 */
  margin: 0 5px; /* 调整日期输入框左右的间距 */
}
</style>
